import React, { useEffect } from "react";
import AvatarImg from "./AvatarImg";
import { useLanguage } from "../i18n/LanguageContext";
import "../styles/birthdayExperience.css";

const SPARKLES = Array.from({ length: 24 }, (_, index) => ({
  id: index,
  left: `${(index * 37) % 96}%`,
  delay: `${(index % 8) * -0.42}s`,
  duration: `${4.5 + (index % 5) * 0.7}s`,
  size: `${5 + (index % 4) * 2}px`,
}));

export default function BirthdayCelebrationScreen({ data, onClose, onOpenWishes }) {
  const { lang } = useLanguage();
  const en = lang === "en";
  const wishes = Array.isArray(data?.wishes) ? data.wishes : [];
  const firstName = String(data?.celebrant?.name || "").trim().split(/\s+/)[0];
  const title = firstName
    ? (en ? `Happy birthday, ${firstName}!` : `İyi ki doğdun, ${firstName}!`)
    : (en ? "Happy birthday!" : "İyi ki doğdun!");
  const visibleWishes = wishes.slice(0, 4);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div className="birthdayCelebration" role="dialog" aria-modal="true" aria-label={title}>
      <div className="birthdayAurora birthdayAuroraOne" />
      <div className="birthdayAurora birthdayAuroraTwo" />
      <div className="birthdaySparkleField" aria-hidden="true">
        {SPARKLES.map((sparkle) => (
          <i key={sparkle.id} style={{
            left: sparkle.left,
            animationDelay: sparkle.delay,
            animationDuration: sparkle.duration,
            width: sparkle.size,
            height: sparkle.size,
          }} />
        ))}
      </div>

      <button type="button" className="birthdayClose" onClick={onClose} aria-label={en ? "Close" : "Kapat"}>×</button>

      <div className="birthdayCelebrationContent">
        <div className="birthdayEyebrow"><span />{en ? "TODAY IS YOUR DAY" : "BUGÜN SENİN GÜNÜN"}<span /></div>
        <div className="birthdayAvatarStage">
          <div className="birthdayAvatarOrbit" />
          <div className="birthdayAvatarHalo" />
          <AvatarImg
            avatar={data?.celebrant?.avatar || null}
            initials={(firstName || "?").charAt(0).toUpperCase()}
            size={112}
            radius={38}
          />
          <div className="birthdayCrown" aria-hidden="true">♛</div>
        </div>

        <h1>{title}</h1>
        <p className="birthdayLead">
          {en
            ? "May this new age bring warm moments, beautiful surprises and many memories with your family."
            : "Yeni yaşın; sıcacık anlar, güzel sürprizler ve ailenle biriktireceğin unutulmaz hatıralarla dolsun."}
        </p>

        <div className="birthdayCake" aria-hidden="true">
          <span className="birthdayFlame" />
          <span className="birthdayCandle" />
          <span className="birthdayCakeTop" />
          <span className="birthdayCakeBase" />
        </div>

        {visibleWishes.length > 0 && (
          <div className="birthdayWishPreview">
            <div className="birthdayWishPreviewTitle">
              <span>💌</span>
              <strong>{en ? "Your family is celebrating you" : "Ailen seni kutluyor"}</strong>
              <small>{wishes.length}</small>
            </div>
            <div className="birthdayWishFaces">
              {visibleWishes.map((wish) => (
                <div className="birthdayWishFace" key={wish.id} title={wish.senderName}>
                  <AvatarImg avatar={wish.senderAvatar || null} initials={String(wish.senderName || "?").charAt(0)} size={36} radius={13} />
                </div>
              ))}
              <span>{wishes[0]?.message || (en ? "Beautiful wishes are waiting for you." : "Seni bekleyen güzel dilekler var.")}</span>
            </div>
          </div>
        )}

        <button type="button" className="birthdayPrimaryAction" onClick={wishes.length ? onOpenWishes : onClose}>
          <span>{wishes.length ? "💌" : "✨"}</span>
          {wishes.length ? (en ? "See birthday wishes" : "Kutlamaları gör") : (en ? "Start my new age" : "Yeni yaşıma başla")}
        </button>
        <button type="button" className="birthdayQuietAction" onClick={onClose}>
          {en ? "Continue to the app" : "Uygulamaya devam et"}
        </button>
      </div>
    </div>
  );
}
